import { defineComponent, openBlock, createElementBlock, Fragment, createCommentVNode, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "ArrowRightCascader"
});
const _hoisted_1 = /* @__PURE__ */ createElementVNode("svg", {
  t: "1663639398537",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "6576",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "16",
  height: "16"
}, [
  /* @__PURE__ */ createElementVNode("path", {
    d: "M256 197.568c0-69.408 45.824-90.368 102.24-46.976l367.424 282.752c56.48 43.424 56.416 113.92 0 157.344L358.24 873.408C301.792 916.864 256 895.68 256 826.464V197.568z",
    "p-id": "6577"
  })
], -1);
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(Fragment, null, [
    createCommentVNode('DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"'),
    _hoisted_1
  ], 2112);
}
var arrowRightCascader = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { arrowRightCascader as default };
